export default {
    props: ['clipboard_event'],
    computed : 
    {        
        event_UI() 
        { 
            var border_color = this.event_border_colour(this.clipboard_event.book_status)
            return { 'border-left-color': border_color, 'border-left-width':'6px' }; 
        },
    },
    methods:{
        event_border_colour(status) 
        {
            if(this.Constants.STATUS_BOOKED == status)
                return this.Constants.STATUS_BOOKED_EVENT_COLOUR
            else if(this.Constants.STATUS_ARRIVED == status)
                return this.Constants.STATUS_ARRIVED_EVENT_COLOUR
            else if(this.Constants.STATUS_COMPLETED == status)
                return this.Constants.STATUS_COMPLETED_EVENT_COLOUR
            else if(this.Constants.STATUS_NO_SHOW == status)
                return this.Constants.STATUS_NO_SHOW_EVENT_COLOUR
            else if(this.Constants.STATUS_EARLY_CANCELLED == status)
                return this.Constants.STATUS_EARLY_CANCELLED_EVENT_COLOUR
            else if(this.Constants.STATUS_LATE_CANCELLED == status)
                return this.Constants.STATUS_LATE_CANCELLED_EVENT_COLOUR
            else
                return "#0084F4"
        }
    }
}